module.exports = __webpack_public_path__ + "img/b6.085cbaab.png";